// @flow
import React from "react";
import { localize } from "redux-i18n";
import { formatDate } from "@transformers/date";
import { SectionComponent } from "@components";

type Props = $Exact<{
  data: Object,
  ...PropsFromLocalize,
}>;

class EmployeeReferralAcknowledgementSection extends React.Component<Props> {
  render() {
    if (this.props.data && this.props.data.dateAcknowledged) {
      return (
        <SectionComponent
          id="employee-referral-acknowledgement"
          title={<h5>{this.props.t("ACKNOWLEDGEMENT")}</h5>}
          wrapperClassName="flex-column my-4"
        >
          <div className="d-flex">
            <div className="d-flex justify-content-between align-items-center mr-2">
              <span>{this.props.t("SUPPLIER_REFERRAL_ACKNOWLEDGEMENT_DATE_TEXT")}</span>
            </div>
            <div className="text-pumpkin-orange font-weight-bold">
              {formatDate(this.props.data.dateAcknowledged)}
            </div>
          </div>
        </SectionComponent>
      );
    }

    return null;
  }
}

export default localize()(EmployeeReferralAcknowledgementSection);
